import _ from "lodash";
import BaseSecondaryStickyView from "scripts/views/baseSecondaryStickyNavView";
import templateAnthologyCollectionPageNav from "templates/anthologyCollectionPageNav.hbs";
import mediaPageNavTranslations from "i18n/mediaPageNavTranslations";

const DEFAULT_SORT = "title asc";

const chan = Backbone.Radio.channel;

class AnthologyCollectionPageNavView extends BaseSecondaryStickyView {
  get template() {
    return templateAnthologyCollectionPageNav;
  }

  constructor(options) {
    super(options);

    this.anthologyCollectionModel = options.anthologyCollectionModel;

    this.mediaPageNavTranslations = new mediaPageNavTranslations();

    this.sortOption = DEFAULT_SORT;

    chan("anthologyCollectionPageContentSubPage").on(
      "sortOptionChange",
      sortOption => {
        this.sortOption = sortOption;
        this.render();
      },
      this,
    );
  }

  get events() {
    return _.extend({}, super.events, {
      "click .sort-option": "onClickSortButton",
    });
  }

  render() {
    this.$el.html(
      this.template(
        _.merge(
          {
            i18n: this.mediaPageNavTranslations.getTranslations(),
            sortOption: this.sortOption,
          },
          this.model.toJSON(),
          this.anthologyCollectionModel.toJSON(),
        ),
      ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }

  onClickSortButton(event) {
    this.sortOption = event.target.value;
    chan("anthologyCollectionPageNav").trigger("sortOptionChange", this.sortOption);
    this.render();
  }
}

export default AnthologyCollectionPageNavView;
